import * as React from "react";
import { Components, Types } from "@sendum/core";

import s from "./VisibilitySensor.module.scss";

interface SensorComponentPropsI {
	sensorData: { value: boolean | number; epoch: number } | undefined;
	sensorName: string;
	onClick: (property: string) => void;
	active: boolean;
	config?: Types.TDeviceAttribute;
	view?: "tile" | "row" | "marken";
	className?: string;
}

export const VisibilitySensor = ({
	sensorData,
	sensorName,
	onClick,
	active,
	config,
	view = "tile",
	className = "",
}: SensorComponentPropsI): JSX.Element => (
	<div className={[s.sensor, className, config?.clickable ? s.sensor_clickable : "", active ? s.sensor_active : ""].join(" ")}>
		<Components.Sensor view={view}
			sensorData={sensorData}
			sensorName={sensorName}
			config={config}
			onClick={onClick}
			active={active}/>
	</div>
);
